import type { HelpFile } from '../../types/help'
import { FieldPaletteTestIds } from '../../../testids/FieldPaletteTestIds'

export const fieldPaletteHelp: HelpFile = {
  docPage: '/docs/schema/form-layouts',
  texts: {
    [FieldPaletteTestIds.paletteRetryBtn]: 'Retry loading the field palette after a failed request to fetch available attributes.',
  },
}
